import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ss_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export { API };
export default api;
